interface EmailMap {
    [key: string]: string;
  }

export const ZoomEmailMap :  EmailMap= {
    "abhay.sangal@infollion.com": "Abhay Sangal",
    "me": "Garima Pathak",
    "parina.kalra@infollion.com": "Parina Kalra",
    "monika.gupta@infollion.com": "Monika Gupta",
    "varun.khandelwal@infollion.com": "Varun Khandelwal",
    "neha.diwakar@infollion.com": "Neha Diwakar",
    "shivika.agarwal@infollion.com": "Shivika Agarwal",
    "ankur.kaul@infollion.com": "Ankur Kaul",
    "ankit.girdhar@infollion.com": "Ankit Girdhar",
    "manika.arora@infollion.com": "Manika Arora",
    "komal.malik@infollion.com": "Komal Malik",
    "mohit.gwal@infollion.com": "Mohit Gwal",
    "vasundhara.srivastava@infollion.com": "Vasundhara Srivastava",
    "arpit.gupta@infollion.com": "Arpit Gupta",
    "disha.agrawal@infollion.com": "Disha Agrawal",
    "riya@infollion.com": "Riya",
    "support@infollionupdates.com": "Support",
  };